import { useTranslation } from "react-i18next";
import { DELIVERY_MODEL } from "../../../Dashboard/Contractors/EquipmentAndMaterial/Model/Model";
import { PHOTO_PICKER_MODEL } from "../../../../components/PhotoPicker/SubComponent/Models/Models";
import { useState } from "react";
import HandleChange from "../../../../Helpers/HandleChange";
import { USER_TYPE_MODEL } from "../../../../enums/userTypeEnum";
/**
 *
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */
const DeliveryModalApp = ({ onHide }) => {
    const { t } = useTranslation();
    const [emptyFields, setEmptyFields] = useState(false); // Indicates if required fields are empty
    const [disabled, setDisabled] = useState(false); // Controls disabled state of the form
    const [selectedList, setSelectedList] = useState([]); // List of selected items
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL }); // Photo picker state
    const [item, setItem] = useState({ ...DELIVERY_MODEL }); // Delivery record model state
    const { handleChange } = HandleChange({ model: item, setModel: setItem }); // Input change handler
    const [displayModal, setDisplayModal] = useState('');
    const [clear, setClear] = useState(false);

    // Confirms the form submission
    const handleConfirm = async () => {
          if (!item.isValid()) {
            setEmptyFields(true);
            return;
        }
    };

    // Clears all form data
    const handleClear = () => {
        DELIVERY_MODEL.clear();
        setItem({ ...DELIVERY_MODEL });
        setSelectedList([]);
        setEmptyFields(false);
        setPhotoPicker({ ...PHOTO_PICKER_MODEL })
        setClear(true);
        setDisplayModal('');
    };
    // User type to filter/search
    const userTypeToSearch = USER_TYPE_MODEL.SUPPLIER_EMPLOYEE;

    return {
        t,
        handleConfirm,
        handleClear,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        disabled,
        item,
        handleChange,
        selectedList,
        userTypeToSearch,
        setSelectedList,
        displayModal,
        setDisplayModal,
        clear,
        setClear
    };
};

export default DeliveryModalApp;
